import { useQuery } from "@tanstack/react-query";
import { getTrendDisplay } from "../repositories/TrendDisplayRepository";

const POLLING_INTERVAL = 4_000;

export const useTrendDisplay = () => {
	return useQuery({
		queryKey: ["trendDisplay"],
		queryFn: ({ signal }) => getTrendDisplay({ signal }),
		refetchInterval: POLLING_INTERVAL,
		refetchIntervalInBackground: false,
	});
};
